/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  disabledFields: string[];
}

const ResultsItem: FunctionComponent<IProps> = ({ result, disabledFields }) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>
        {isEnabled('bridleNumber') && (
          <div className="fw-7">{result.bridleNumber}</div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center">
          <img src={helmetIcon} className="mr-11" alt="" />
          <div className="fs-12 fw-7 text-nowrap">
            {result.riderFirstName} {result.riderLastName}
          </div>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <img src={horseIcon} className="mr-11" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7">{result.horseName}</div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}
            </div>
          </div>
        </div>
      </td>
      <td>{isEnabled('dressageTime') && result.dressageTime}</td>
      <td>{isEnabled('htJumpPenalties') && result.htJumpPenalties}</td>
      <td>{isEnabled('htTimeTaken') && result.htTimeTaken}</td>
      <td>{isEnabled('htTimePenalties') && result.htTimePenalties}</td>
      <td>{isEnabled('htTotalScore') && result.htTotalScore}</td>
      <td>{isEnabled('sectionPlace') && result.sectionPlace}</td>
      <td>{isEnabled('overallPlace') && result.overallPlace}</td>
      <td>
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">{result.riderClassStatusCode}</div>
        )}
      </td>
    </tr>
  );
};

export default memo(ResultsItem);
